/**
 * @module MailchimpPopup
 * @description No-op placeholder — Mailchimp script is now embedded directly
 * in public/index.html as <script id="mcjs" src="...chimpstatic.com...">.
 *
 * WHY the script moved to index.html:
 * Mailchimp's "site connected" verification is a static HTTP crawler that reads
 * raw HTML. Dynamic JS injection (the previous approach) is invisible to it,
 * causing the dashboard to report "Site not connected" and stopping popup
 * delivery. The script must be a literal tag in the initial HTML response.
 *
 * Popup display (timing, triggers, full-screen vs widget layout) is configured
 * in the Mailchimp audience dashboard — no code change is needed here.
 * CSP already allows script-src https://chimpstatic.com (Go middleware).
 */

export default function MailchimpPopup() {
  // Render nothing — script is in public/index.html.
  return null;
}
